import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CustomAlert } from 'components/AlertsCollection';

interface MeteorologyFieldsGroupLocationFeedbackState {
  deleteSuccessDialogOpen: boolean;
  deleteErrorDialogOpen: boolean;
  deleteMessage: string | undefined;
  createAlert: CustomAlert | undefined;
  editAlert: CustomAlert | undefined;
}

const initialState: MeteorologyFieldsGroupLocationFeedbackState = {
  deleteSuccessDialogOpen: false,
  deleteErrorDialogOpen: false,
  deleteMessage: undefined,
  createAlert: undefined,
  editAlert: undefined,
};

export const meteorologyFieldsGroupLocationFeedbackSlice = createSlice({
  name: 'meteorologyFieldsGroupLocationFeedback',
  initialState,
  reducers: {
    setDeleteSuccessDialogOpen: (state, action: PayloadAction<boolean>) => {
      state.deleteSuccessDialogOpen = action.payload;
    },
    setDeleteErrorDialogOpen: (state, action: PayloadAction<boolean>) => {
      state.deleteErrorDialogOpen = action.payload;
    },
    setDeleteMessage: (state, action: PayloadAction<string | undefined>) => {
      state.deleteMessage = action.payload;
    },
    setCreateAlert: (state, action: PayloadAction<CustomAlert | undefined>) => {
      state.createAlert = action.payload;
    },
    setEditAlert: (state, action: PayloadAction<CustomAlert | undefined>) => {
      state.editAlert = action.payload;
    },
  },
});

export const selectMeteorologyFieldsGroupLocationDeleteSuccessDialogOpen = (state: any) => (
  state.meteorologyFieldsGroupLocationFeedback.deleteSuccessDialogOpen
);

export const selectMeteorologyFieldsGroupLocationDeleteErrorDialogOpen = (state: any) => (
  state.meteorologyFieldsGroupLocationFeedback.deleteErrorDialogOpen
);

export const selectMeteorologyFieldsGroupLocationMessage = (state: any) => (
  state.meteorologyFieldsGroupLocationFeedback.deleteMessage
);

export const selectMeteorologyFieldsGroupLocationCreateAlert = (state: any) => (
  state.meteorologyFieldsGroupLocationFeedback.createAlert
);

export const selectMeteorologyFieldsGroupLocationEditAlert = (state: any) => (
  state.meteorologyFieldsGroupLocationFeedback.editAlert
);

export const {
  setDeleteSuccessDialogOpen,
  setDeleteErrorDialogOpen,
  setDeleteMessage,
  setCreateAlert,
  setEditAlert,
} = meteorologyFieldsGroupLocationFeedbackSlice.actions;

export default meteorologyFieldsGroupLocationFeedbackSlice.reducer;
